export const APIErrorCode = {
    SESSION_EXPIRED: 1376331503,
    NOT_AUTHORIZED: 1454496734,
    PAYMENT_CANNOT_BE_CANCELLED: 1610441436,
    BOOKING_OUTSIDE_CHILD_DATES: 1781092747,
    SIDEKICK_ENTITLEMENT_LOST: 1786536710,
    SIDEKICK_CONVERSATION_OUT_OF_DATE: 1769525194,
};
